//@ts-check

class LocalStorage {

  /**
   * @param {string} key
   * @param {any} value
   */
  write(key, value) {
    if (value === null) {
      localStorage.removeItem(key)
    } else if (typeof value === 'boolean') {
      localStorage.setItem(key, value ? 'true' : 'false');
    } else if (typeof value === 'object') {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      localStorage.setItem(key, value);
    }
  }

  /**
   * @param {string} key
   */
  read(key) {
    let tmp = localStorage.getItem(key);
    if (tmp === 'true') {
      return true;
    } else if (tmp === 'false') {
      return false;
    }
    try {
      return JSON.parse(tmp);
    } catch (e) {
      return tmp;
    }
  }
}

let storage = new LocalStorage();

export { storage as LocalStorage };